import React from 'react';

const FixedDivs = () => {
  return (
    <>
      <div className='right_fixed_div1'>
        <a href='tel:1483'>
          <img src='../../images/cl-1.png' alt='Phone Number' />
        </a>
      </div>
      <div className='right_fixed_div2'>
        <a href='/contact'>
          <img src='../../images/ml.png' alt='Email' />
        </a>
      </div>
    </>
  );
};

export default FixedDivs;
